import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/clenstvi" as const,
	[Locale.en]: "/membership" as const,
} satisfies LocalizedString;

export function getMembershipPagePath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
